import React from 'react';
import { Grid, Segment, Button, Table, Header, Accordion, Icon, Label } from 'semantic-ui-react';
import _ from 'underscore';
import moment from 'moment';
import { render } from 'react-dom';
const POLICY_NO_SMU = ['2100653158', '2100653765'];

class SysadminUserUserUploadUserTable extends React.Component {

    renderField(label, value){
        return (
            <>
                <Table.Cell style={{ backgroundColor: "#F9FAFB" }}>
                    <strong> {label} </strong>
                </Table.Cell>
                <Table.Cell> 
                    <span> {value} </span>
                </Table.Cell>
            </>
        )
    }

    renderFieldError(label, value){
        return (
            <>
                <Table.Cell style={{ backgroundColor: "#F9FAFB" }}>
                    <strong style={{ color: "#FF0000" }}> {label} </strong>
                </Table.Cell>
                <Table.Cell> 
                    <span style={{ color: "#FF0000" }}> {value} </span>
                </Table.Cell>
            </>
        )
    }

    renderFieldWarning(label, value){
        return (
            <>
                <Table.Cell style={{ backgroundColor: "#F9FAFB" }}>
                    <strong style={{ color: "#FFA500" }}> {label} </strong>
                </Table.Cell>
                <Table.Cell> 
                    <span style={{ color: "#FFA500" }}> {value} </span>
                </Table.Cell>
            </>
        )
    }

    renderDate(label, date, dateFormatIn='x', dateFormatOut='DD-MMM-YYYY'){

        if(!date) return this.renderField(label, '');

        // Get date in valid format
        let result = moment(date, dateFormatIn, true);

        // Handle only for effective end date
        if(label === 'Effective End Date'){
            if(!result.isValid()){
                return this.renderFieldError(label, result.format(dateFormatOut))
            }else{
                // Get today date
                const todayDate = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
                const todayDateValue = todayDate.valueOf();

                // Get effectiveEndDate 
                const effectiveEndDateMoment = moment(date).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
                const effectiveEndDateValue = effectiveEndDateMoment.valueOf();

                // Compare date
                if (effectiveEndDateValue <= todayDateValue) {
                    return this.renderFieldWarning('Effective End Date', result.format(dateFormatOut));
                }else{
                    return this.renderField('Effective End Date', result.format(dateFormatOut));
                }
            }
        }

        // Handle other
        if(result.isValid()){
            return this.renderField(label, result.format(dateFormatOut));
        }else{
            return this.renderFieldError(label, result.format(dateFormatOut))
        }
    }

    render() {

        return (
            <>
                <Segment style={{margin:"0"}}>
                    {
                        _.map(this.props.newUsers, (user, index) => {
                            const {
                                name,
                                nric,
                                birthdate,
                                gender,
                                designation,
                                planNo,
                                costCenter,
                                effectiveStartDate,
                                effectiveEndDate,
                                newNric,
                                changeEffectiveDate,
                                bankNo,
                                branchNo,
                                accountNo,
                                email,
                                loginRequired,
                                companies,
                                studentFullBankAccountNo,
                                studentEmail,
                                studentTel,
                                studentCareerCode,
                                studentMaritalStatus,
                                studentID,
                                studentNationality,
                                singaporeCitizenshipstatus,
                                nsMenIndicator,
                            } = user;

                            // check if contain SMU data
                            const isSMUUser = user.companies.find(comp => (POLICY_NO_SMU.includes(comp.companyCode)));

                            return (
                                <React.Fragment key={index}>
                                    <Header as="h3" textAlign="center" style={{ margin: "10px 0" }}>User Data</Header>
                                    <Table celled fixed>
                                        <Table.Body>
                                            <Table.Row>
                                                <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong>Name</strong></Table.Cell>
                                                <Table.Cell>{name}</Table.Cell>
                                                <Table.Cell style={{ backgroundColor: "#F9FAFB" }}> <strong> NRIC </strong></Table.Cell>
                                                <Table.Cell>{nric}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Gender </strong></Table.Cell>
                                                <Table.Cell>{gender}</Table.Cell>
                                                {this.renderDate('Birthdate', birthdate)}
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Email </strong></Table.Cell>
                                                <Table.Cell>{email}</Table.Cell>
                                                <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Login Required </strong></Table.Cell>
                                                <Table.Cell>{loginRequired}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Bank Code </strong></Table.Cell>
                                                <Table.Cell>{bankNo}</Table.Cell>
                                                <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Branch Code </strong></Table.Cell>
                                                <Table.Cell>{branchNo}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Account No </strong></Table.Cell>
                                                <Table.Cell>{accountNo}</Table.Cell>
                                                {newNric && this.renderFieldWarning('New NRIC', newNric)}
                                            </Table.Row>
                                            <Table.Row>

                                            </Table.Row>
                                        </Table.Body>
                                    </Table>
                                    <br />

                                    {/* Display SMU Data */}
                                    {isSMUUser &&
                                        <React.Fragment>
                                            <Header as="h3" textAlign="center" style={{ margin: "10px 0" }}>SMU Data</Header>
                                            <Table celled fixed>
                                                <Table.Body>
                                                    <Table.Row>
                                                        <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Student ID </strong></Table.Cell>
                                                        <Table.Cell>{studentID}</Table.Cell>
                                                        <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Student Email</strong></Table.Cell>
                                                        <Table.Cell>{studentEmail}</Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell style={{ backgroundColor: "#F9FAFB" }}> <strong> Student Career Code </strong></Table.Cell>
                                                        <Table.Cell>{studentCareerCode}</Table.Cell>
                                                        <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Student Tel </strong></Table.Cell>
                                                        <Table.Cell>{studentTel}</Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Student Marital Status </strong></Table.Cell>
                                                        <Table.Cell>{studentMaritalStatus}</Table.Cell>
                                                        <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Student Nationality </strong></Table.Cell>
                                                        <Table.Cell>{studentNationality}</Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Singapore CitizenshipSstatus </strong></Table.Cell>
                                                        <Table.Cell>{singaporeCitizenshipstatus}</Table.Cell>
                                                        <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> nsMen Indicator </strong></Table.Cell>
                                                        <Table.Cell>{nsMenIndicator}</Table.Cell>
                                                    </Table.Row>
                                                </Table.Body>
                                            </Table>
                                            <br/>
                                        </React.Fragment>
                                    }

                                    {companies.map((company, companyIndex) => {
                                        return (
                                            <React.Fragment key={companyIndex}>
                                                <Segment>
                                                    <Grid >
                                                        <Grid.Row style={{ padding: "20px 0 0 0" }}>
                                                            <Grid.Column><Header as="h3" textAlign="center">Company Data ({(companyIndex + 1) + "/" + companies.length})</Header></Grid.Column>
                                                        </Grid.Row>
                                                        <Grid.Row>
                                                            <Grid.Column>
                                                                <Table celled fixed>
                                                                    <Table.Body>
                                                                        <Table.Row>
                                                                            <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Company Name </strong></Table.Cell>
                                                                            <Table.Cell>{company.companyName}</Table.Cell>
                                                                            <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Company Code </strong></Table.Cell>
                                                                            <Table.Cell>{company.companyCode}</Table.Cell>
                                                                        </Table.Row>
                                                                        <Table.Row>
                                                                            <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Designation </strong></Table.Cell>
                                                                            <Table.Cell>{company.designation}</Table.Cell>
                                                                            <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Plan No </strong></Table.Cell>
                                                                            <Table.Cell>{company.planNo}</Table.Cell>
                                                                        </Table.Row>
                                                                        <Table.Row>
                                                                            <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Cost Center </strong></Table.Cell>
                                                                            <Table.Cell>{company.costCenter}</Table.Cell>
                                                                            <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Cost Center Name </strong></Table.Cell>
                                                                            <Table.Cell>{company.costCenterName}</Table.Cell>
                                                                        </Table.Row>
                                                                        <Table.Row>
                                                                            {this.renderDate('Effective Start Date', company.effectiveStartDate)}
                                                                            {this.renderDate('Effective End Date', company.effectiveEndDate)}
                                                                        </Table.Row>
                                                                        <Table.Row>
                                                                            <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Staff ID </strong></Table.Cell>
                                                                            <Table.Cell>{company.staffId}</Table.Cell>
                                                                        </Table.Row>
                                                                    </Table.Body>
                                                                </Table>
                                                            </Grid.Column>
                                                        </Grid.Row>

                                                        {/* Display Dependent */}
                                                        <Grid.Row style={{ paddingBottom: "0" }}>
                                                            <Grid.Column><Header as="h3" textAlign="center">Dependents Data</Header></Grid.Column>
                                                        </Grid.Row>
                                                        <Grid.Row>
                                                            <Grid.Column>
                                                                {Array.isArray(company.family) && company.family.length <= 0 ?
                                                                    <Grid.Column> <Segment>No Dependent Data</Segment> </Grid.Column> :
                                                                    <Grid.Column>
                                                                        {company.family.map((fam, famIndex) => {
                                                                            return (
                                                                                <React.Fragment key={famIndex}>
                                                                                    <Table celled fixed>
                                                                                        <Table.Body>
                                                                                            <Table.Row>
                                                                                                <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Dependent Name </strong></Table.Cell>
                                                                                                <Table.Cell >{fam.name}</Table.Cell>
                                                                                                <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Dependent NRIC </strong></Table.Cell>
                                                                                                <Table.Cell>{fam.nric}</Table.Cell>
                                                                                            </Table.Row>
                                                                                            <Table.Row>
                                                                                                {this.renderDate('Birthdate', fam.birthdate)}
                                                                                                <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Relationship </strong></Table.Cell>
                                                                                                <Table.Cell>{fam.relationship}</Table.Cell>
                                                                                            </Table.Row>
                                                                                            <Table.Row>
                                                                                                {this.renderDate('Effective Start Date', fam.effectiveStartDate)}
                                                                                                {this.renderDate('Effective End Date', fam.effectiveEndDate)}
                                                                                            </Table.Row>
                                                                                            <Table.Row>
                                                                                            <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Dependent Email </strong></Table.Cell>
                                                                                                <Table.Cell>{fam.email}</Table.Cell>
                                                                                                <Table.Cell style={{ backgroundColor: "#F9FAFB" }}><strong> Plan No </strong></Table.Cell>
                                                                                                <Table.Cell>{fam.planNo}</Table.Cell>
                                                                                            </Table.Row>
                                                                                            {fam.newDependentNric && 
                                                                                                <Table.Row>
                                                                                                    {this.renderFieldWarning('New NRIC', fam.newDependentNric)}
                                                                                                </Table.Row>
                                                                                            }

                                                                                        </Table.Body>
                                                                                    </Table>
                                                                                </React.Fragment>
                                                                            )
                                                                        })}
                                                                    </Grid.Column>
                                                                }
                                                            </Grid.Column>

                                                        </Grid.Row>

                                                    </Grid>
                                                    <br />
                                                </Segment>
                                                <br />
                                            </React.Fragment>
                                        )
                                    })}

                                </React.Fragment>
                            );
                        })
                    }
                </Segment>
            </>
        );
    }

}

export default SysadminUserUserUploadUserTable;